import {
    CONNECT_SOCKET, DISCONNECT_SOCKET, SUBSCRIBE,
    CONNECTED_SOCKET, MESSAGE_RECEIVED, UNSUBSCRIBE,
    LIVE_MESSAGE, SEND_COMMAND, UPDATE_LIVE_DATA_SHOW
} from '../constants/action-types';

export const connectSocket = () => ({ type: CONNECT_SOCKET });

export const connectedSocket = isConnected => ({ type: CONNECTED_SOCKET, isConnected });

export const disconnectSocket = () => ({ type: DISCONNECT_SOCKET });

export const socketError = error => ({ type: DISCONNECT_SOCKET, error });

export const subscribe = (notifications, group, trackMessages) => ({ type: SUBSCRIBE, notifications, group, trackMessages });

export const unsubscribe = (group, clearMessages) => ({ type: UNSUBSCRIBE, group, clearMessages });

export const messageReceived = message => ({ type: MESSAGE_RECEIVED, message });

export const liveMessage = message => ({ type: LIVE_MESSAGE, message });

export const sendCommand = params => ({ type: SEND_COMMAND, params });

export const updateLiveDataShow = () => ({ type: UPDATE_LIVE_DATA_SHOW });